import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Simple module-level cache — the config never changes during a session and
// every page (landing, pricing, signup) reads it. One fetch on first mount.
let _cache = null;
let _pending = null;

async function fetchOnce() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = api.get("/platform/config").then((r) => {
    _cache = r.data;
    _pending = null;
    return _cache;
  }).catch(() => {
    // On failure, assume production defaults (invite-only) so we do not
    // accidentally show a public signup form.
    _cache = {
      public_signup_enabled: false,
      invite_only_mode: true,
      billing_mode: "disabled",
      xendit_mode: "test",
      app_url: null,
      marketing_url: null,
      email_configured: false,
      beta_message: "TOVRA is currently available through private beta access.",
    };
    _pending = null;
    return _cache;
  });
  return _pending;
}

export function usePlatformConfig() {
  const [config, setConfig] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    let cancelled = false;
    fetchOnce().then((c) => { if (!cancelled) setConfig(c); });
    return () => { cancelled = true; };
  }, []);
  return config;
}
